export const getCoordinatesFromAddress = async (address: string) => {
    if (window?.google?.maps?.Geocoder) {
        const geocoder = new window.google.maps.Geocoder()
    
        try {
            const response = await geocoder?.geocode({ address })
            const location = response.results[0]?.geometry?.location || {}
    
            return { lat: location?.lat(), lng: location?.lng() }
        } catch (error) {
            console.error('[Sesami] Geocode has error:', error)
        }
    }
    
}
